import { StaffService } from './../../../_services/staff.service';
import { PaginationInfo } from './../../../_models/pagination-info';
import { LearningPathService } from './../../../_services/learning-path.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalService } from '../../../_services/global.service';
import { ResponseStructure } from '@iq-central-front-end/share';
import {
  trigger,
  transition,
  group,
  style,
  query,
  animate,
} from '@angular/animations';
@Component({
  selector: 'iq-central-front-end-view-learning-path',
  templateUrl: './view-learning-path.component.html',
  styleUrls: ['./view-learning-path.component.scss'],
  animations: [
    trigger('carouselAnimation', [
      // company-information. other-details, verify-email, other-information
      transition('choose-dueDate => select-participants', [
        group([
          query(
            ':enter',
            [
              style({ transform: 'translateX(calc((-100vw + 335px)))' }),
              animate('0.35s ease-in-out', style({ transform: 'none' })),
            ],
            { optional: true }
          ),
        ]),
      ]),

      transition('select-participants => choose-dueDate', [
        group([
          query(
            ':enter',
            [
              style({ transform: 'translateX(calc((100vw + 335px)))' }),
              animate('0.3s ease-in-out', style({ transform: 'none' })),
            ],
            { optional: true }
          ),
        ]),
      ]),
    ]),
  ],
})
export class ViewLearningPathComponent implements OnInit, OnDestroy {
  minDate: Date = new Date();
  currentPage = 'select-participants';
  sub: Subscription = new Subscription();
  dueDate: Date;
  to: any;
  selectedDepartments: any[] = [];
  selectedDivisions: any[] = [];
  selectedUnits: any[] = [];
  departments: any[] = [];
  divisions: any[] = [];
  units: any[] = [];
  courses: any[] = [];
  learningPath: any;
  selectedStaffs: any[] = [];
  staffs: any[] = [];
  filteredStaffs: any;
  filteredDepartments: any;
  filteredDivisions: any;
  filteredUnits: any;
  staffPaginationInfo: PaginationInfo;
  lists;
  constructor(
    private route: ActivatedRoute,
    private _learningPath: LearningPathService,
    private _global: GlobalService,
    private _staff: StaffService
  ) {}

  ngOnInit(): void {
    this.getResolvedData();

    this.lists = [1, 2, 3, 4, 5, 6, 7];
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.learningPath = res['resolvedData'].learningPath['responseResult'];
        this.courses = this.learningPath['courses'];
        this.staffs = this.filteredStaffs =
          res['resolvedData'].staffs['responseResult'].users;
        this.departments = this.filteredDepartments =
          res['resolvedData'].departments['responseResult'];
        this.divisions = this.filteredDivisions =
          res['resolvedData'].divisions['responseResult'];
        this.units = this.filteredUnits =
          res['resolvedData'].units['responseResult'];
        this.staffPaginationInfo =
          res['resolvedData'].staffs['responseResult'].paginationInfo;
      })
    );
  }

  filterStaff(query: string) {
    this.staffs = query
      ? this.filteredStaffs.filter((c) =>
          c.user.fullName.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredStaffs;
  }

  filterDepartment(query: string) {
    this.departments = query
      ? this.filteredDepartments.filter((c) =>
          c.name.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredDepartments;
  }

  filterDivision(query: string) {
    this.divisions = query
      ? this.filteredDivisions.filter((c) =>
          c.name.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredDivisions;
  }

  filterUnit(query: string) {
    this.units = query
      ? this.filteredUnits.filter((c) =>
          c.name.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredUnits;
  }

  sortByName() {
    this.staffs.sort((a, b) => {
      if (a.user.fullNamee < b.user.fullName) return -1;
      else if (a.user.fullName > b.user.fullName) return 1;
      else return 0;
    });
  }

  sortByDate() {
    this.staffs.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  navigateStaffNextPage(page) {
    this._global.showSpinner();
    this._staff.getActiveEnterpriseUsers(page, 6).subscribe({
      next: (res) => {
        this._global.hideSpinner();
        this.staffs = res['responseResult'].users;
        this.staffPaginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }
  deleteLearningPath(id) {
    this._global.showSpinner();
    this.sub.add(
      this._learningPath.deleteLearningPath(id).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  selectDeselctStaff(staffId) {
    this.selectedStaffs.includes(staffId)
      ? (this.selectedStaffs = this.selectedStaffs.filter(
          (sId) => sId !== staffId
        ))
      : this.selectedStaffs.push(staffId);

    console.log(this.selectedStaffs);
  }
  selectDeselectDepartments(departmentId) {
    this.selectedDepartments.includes(departmentId)
      ? (this.selectedDepartments = this.selectedDepartments.filter(
          (sId) => sId != departmentId
        ))
      : this.selectedDepartments.push(departmentId);
    console.log(this.selectedDepartments);
  }
  selectDeselectDivisions(divisionId) {
    this.selectedDivisions.includes(divisionId)
      ? (this.selectedDivisions = this.selectedDivisions.filter(
          (sId) => sId != divisionId
        ))
      : this.selectedDivisions.push(divisionId);
    console.log(this.selectedDivisions);
  }
  selectDeselectUnits(unitId) {
    this.selectedUnits.includes(unitId)
      ? (this.selectedUnits = this.selectedUnits.filter((sId) => sId != unitId))
      : this.selectedUnits.push(unitId);
    console.log(this.selectedUnits);
  }
  assign() {
    if (this.to == 'staff') {
      this.assignToStaffs();
    } else if (this.to == 'department') {
      this.assignToDepartment();
    } else if (this.to == 'division') {
      this.assignToDivision();
    } else if (this.to == 'unit') {
      this.assignToUnit();
    }
  }
  assignToStaffs() {
    this._global.showSpinner();
    const payload = {
      ids: this.selectedStaffs,
      learningPaths: [this.learningPath?.id],
      dueDate: this.dueDate,
    };

    this.sub.add(
      this._learningPath.assignLpToStaffs(payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  assignToDepartment() {
    this._global.showSpinner();
    const payload = {
      ids: this.selectedDepartments,
      learningPaths: [this.learningPath?.id],
      dueDate: this.dueDate,
    };

    this.sub.add(
      this._learningPath.assignLpToDepartments(payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  assignToUnit() {
    this._global.showSpinner();
    const payload = {
      ids: this.selectedUnits,
      learningPaths: [this.learningPath?.id],
      dueDate: this.dueDate,
    };

    this.sub.add(
      this._learningPath.assignLpToUnits(payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  assignToDivision() {
    this._global.showSpinner();
    const payload = {
      ids: this.selectedDivisions,
      learningPaths: [this.learningPath?.id],
    };

    this.sub.add(
      this._learningPath.assignLpToDivisions(payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }
  onDueDateChange(event) {
    this.dueDate = event;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  chooseDate(page, to) {
    console.log(page, to);
    this.currentPage = page;
    this.to = to;
  }

  rating(course) {
    var total = 0;
    for (var i in course.courseRatings) {
      total += course.courseRatings[i].rating;
    }
    const rating = total / course.courseRatings.length;
    if (rating >= 1 && rating < 2) {
      return 'one';
    } else if (rating >= 2 && rating < 3) {
      return 'two';
    } else if (rating >= 3 && rating < 4) {
      return 'three';
    } else if (rating >= 4 && rating < 5) {
      return 'four';
    } else if (rating >= 5) {
      return 'five';
    }
  }
}
